import React, {Component} from 'react'

import DatasetComponent from './Dataset.component'

class DatasetContainer extends Component {
  render() {
    return (
      <DatasetComponent>
        {this.props.children}
      </DatasetComponent>
    )
  }
}

export default DatasetContainer
